export const version = "bignumber/5.0.12";
//# sourceMappingURL=_version.js.map